module.exports = __webpack_public_path__ + "static/media/img3-2.9757c0a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/biosense/diff/img3-2.png
// module id = 1530
// module chunks = 3